export default __webpack_public_path__ + "20bacd9d912bdb4930089f162cbe7ad8.png";